import { useDeleteDashboardFolderModalModel } from './delete-dashboard-folder-modal.model'
import type { IBaseDeleteDashboardFolderModalProps } from './delete-dashboard-folder-modal.types'
import { DeleteDashboardFolderModalView } from './delete-dashboard-folder-modal.view'

export const DeleteDashboardFolderModal = ({ isOpen }: IBaseDeleteDashboardFolderModalProps) => {
  const deleteDashboardFolderModalModel = useDeleteDashboardFolderModalModel()
  return <DeleteDashboardFolderModalView isOpen={isOpen} {...deleteDashboardFolderModalModel} />
}
